import React from 'react';
import Hdr from './shared/Hdr';
import { useState, useEffect } from 'react';
import swal from 'sweetalert';
import { apiPath } from "../src/services/apiConfig";

function Scheduler() {
  const user = localStorage.getItem('user-info');
  const token = localStorage.getItem('token');
  const usrRole = localStorage.getItem('user-role');
  const [displaySchedule, setDisplaySchedule] = useState('none');
  const [displayUpdSchedule, setDisplayUpdSchedule] = useState('none');
  const [data, setData] = useState([]);
  const [dataStat, setDataStat] = useState();
  const [updDoctorsName, setDoctorsNameUpd] = useState('');
  const [updDays, setDaysUpd] = useState('')
  const [updTime, setTimeUpd] = useState('')
  const [updMon, setMonUpd] = useState()
  const [updTue, setTueUpd] = useState()
  const [updWed, setWedUpd] = useState()
  const [updThu, setThuUpd] = useState()
  const [updFri, setFriUpd] = useState()
  const [updSat, setSatUpd] = useState()
  const [updSun, setSunUpd] = useState()
  const [updSchId, setSchIdUpd] = useState('')
  //  const [updatedDays, setDaysUpdated] = useState('')
  //  const [updatedTime, setTimeUpdated] = useState('')
  const [updatedMon, setMonUpdated] = useState('')
  const [updatedTue, setTueUpdated] = useState('')
  const [updatedWed, setWedUpdated] = useState('')
  const [updatedThu, setThuUpdated] = useState('')
  const [updatedFri, setFriUpdated] = useState('')
  const [updatedSat, setSatUpdated] = useState('')
  const [updatedSun, setSunUpdated] = useState('')
  const [verfied, setVerfied] = useState(false);
  //  const [Err, SetErr] = useState([]);
  const [doctorStat, setDoctorStat] = useState('')
  const [doctorData, setDoctorsData] = useState([])
  const [doctorID, setDoctorID] = useState(0)

  const [days, setDays] = useState('')
  const [time, setTime] = useState('')
  const [mon, setMon] = useState('N')
  const [tue, setTue] = useState('N')
  const [wed, setWed] = useState('N')
  const [thu, setThu] = useState('N')
  const [fri, setFri] = useState('N')
  const [sat, setSat] = useState('N')
  const [sun, setSun] = useState('N')

  let txt = "";

  useEffect(() => {
    getDoctor()
    getSchedule()
  }, [])

  function openSchedule() {
    setDisplaySchedule('block')
  }

  function closeSchedule() {
    setDisplaySchedule('none')
  }

  function openUpdSchedule() {
    setDisplayUpdSchedule('block')
  }

  function closeUpdSchedule() {
    setDisplayUpdSchedule('none')
  }


  function handleMonCheck(e) {
    if (e.target.checked === true) { setMon('Y') } else { setMon('N') }
  }
  function handleTueCheck(e) {
    if (e.target.checked === true) { setTue('Y') } else { setThu('N') }
  }
  function handleWedCheck(e) {
    if (e.target.checked === true) { setWed('Y') } else { setWed('N') }
  }
  function handleThuCheck(e) {
    if (e.target.checked === true) { setThu('Y') } else { setThu('N') }
  }
  function handleFriCheck(e) {
    if (e.target.checked === true) { setFri('Y') } else { setFri('N') }
  }
  function handleSatCheck(e) {
    if (e.target.checked === true) { setSat('Y') } else { setSat('N') }
  }
  function handleSunCheck(e) {
    if (e.target.checked === true) { setSun('Y') } else { setSun('N') }
  }

  function updSunCheck(e) {
    // alert(e.target.checked)
    if (e.target.checked === true) { setSunUpdated('Y') } else { setSunUpdated('N') }
  }
  function updMonCheck(e) {
    //  alert(e.target.checked)
    if (e.target.checked === true) { setMonUpdated('Y') } else { setMonUpdated('N') }
  }
  function updTueCheck(e) {
    if (e.target.checked === true) { setTueUpdated('Y') } else { setTueUpdated('N') }
  }
  function updWedCheck(e) {
    if (e.target.checked === true) { setWedUpdated('Y') } else { setWedUpdated('N') }
  }
  function updThuCheck(e) {
    if (e.target.checked === true) { setThuUpdated('Y') } else { setThuUpdated('N') }
  }
  function updFriCheck(e) {
    if (e.target.checked === true) { setFriUpdated('Y') } else { setFriUpdated('N') }
  }
  function updSatCheck(e) {
    if (e.target.checked === true) { setSatUpdated('Y') } else { setSatUpdated('N') }
  }

  async function updateSchedule(id) {

    let result = await fetch(apiPath + "schedules/" + id, {
      method: 'PUT',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        "DaysOfWeek": updDays,
        "time": updTime,
        "Monday": updatedMon,
        "Tuesday": updatedTue,
        "Wednesday": updatedWed,
        "Thursday": updatedThu,
        "Friday": updatedFri,
        "Saturday": updatedSat,
        "Sunday": updatedSun
      })
    });

    result = await result.json();

    showSwal(result.success, result.message)

    getSchedule()
  }

  async function deleteSchedule(id) {

    let result = await fetch(apiPath + "schedules/" + id, {
      method: 'DELETE',
      headers: {
        "Authorization": `Bearer ${token}`
      },
    });
    result = await result.json();

    showSwal(result.success, result.message)

    getSchedule()
  }

  async function updateOperation(id) {

    let result = await fetch(apiPath + "schedules/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",

          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    console.warn(result.data)

    setSchIdUpd(result.data.scheduleId);
    //    setDoctorsIdUpd(result.data.doctorId);
    setDoctorsNameUpd(result.data.doctorName)
    setDaysUpd(result.data.DaysOfWeek)
    setTimeUpd(result.data.time)
    setSunUpdated(result.data.Sunday)
    setMonUpdated(result.data.Monday)
    setTueUpdated(result.data.Tuesday)
    setWedUpdated(result.data.Wednesday)
    setThuUpdated(result.data.Thursday)
    setFriUpdated(result.data.Friday)
    setSatUpdated(result.data.Saturday)

    if (result.data.Monday === 'Y') { setMonUpd(true) } else { setMonUpd(false) }
    if (result.data.Tuesday === 'Y') { setTueUpd(true) } else { setTueUpd(false) }
    if (result.data.Wednesday === 'Y') { setWedUpd(true) } else { setWedUpd(false) }
    if (result.data.Thusday === 'Y') { setThuUpd(true) } else { setThuUpd(false) }
    if (result.data.Friday === 'Y') { setFriUpd(true) } else { setFriUpd(false) }
    if (result.data.Saturday === 'Y') { setSatUpd(true) } else { setSatUpd(false) }
    if (result.data.Sunday === 'Y') { setSunUpd(true) } else { setSunUpd(false) }

    openUpdSchedule();
  }

  function deleteOperation(id) {
    // alert(id)
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          deleteSchedule(id);
        }
        else {
          swal("Your record is safe!");
        }
      });
  }

  //* LIST OF ALL SCHEDULES (for initial screen)*/ 

  async function getSchedule() {
    let result = await fetch(apiPath + "schedules",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      })

    result = await result.json();
    setDataStat(result.success);
    setData(result.data);
    if (result.success === true) {
      setData(result.data);
    } else { setData([]) }
  }

  //* LIST OF ALL DOCTORS (for initial screen)*/ 

  async function getDoctor() {
    let result = await fetch(apiPath + "doctors",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      })

    result = await result.json();

    setDoctorStat(result.success);
    setDoctorsData(result.data);
    if (result.success === true) {
      setDoctorsData(result.data);
    } else { setDoctorsData([]) }
  }

  function verifySchedule() {
    // alert('Verify '+doctorID+", "+days+','+time+", "+mon)
    if (doctorID === 0) {
      swal('Select Doctor')
      setVerfied(false)
    }
    setVerfied(true)
    addSchedule()
  }

  //*ADD A NEW SCHEDULE*/ 
  async function addSchedule() {

    if (verfied) {

      let result = await fetch(apiPath + "schedules", {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          "doctorId": doctorID,
          "DaysOfWeek": days,
          "time": time,
          "Monday": mon,
          "Tuesday": tue,
          "Wednesday": wed,
          "Thursday": thu,
          "Friday": fri,
          "Saturday": sat,
          "Sunday": sun
        })
      });
      result = await result.json();
      //  console.warn(result)

      //      if (result.success) { }
      //      else {
      //        SetErr(result.data);
      //      }

      showSwal(result.success, result.message)
      getSchedule()
      //         console.warn(Err)
      //         console.warn(Err.toString())
    }
  }

  function showSwal(stat, txt) {
    if (stat === true) {
      swal({
        title: "Success!",
        text: txt,
        icon: "success",
        button: "OK!",
      });
    } else {
      swal({
        title: "Fail!",
        text: txt,
        icon: "error",
        button: "OK!",
      });
    }
  }

  return (

    <div style={{ 'height': '90vh' }}>
      <Hdr />
      <div className="row p16">
        <div className="c12-l-8">
          <h3 className="" >ADS Hospital - User : {user} </h3>
        </div>
        <div className="c12-l-4 pr32 ">
          <p className="medium right">User : ({usrRole})</p>
        </div>
      </div>

      <div className="row p16" style={{ 'height': '90%' }}>
        <div className=" c12-l-12 cont__content p4" style={{ 'height': '100%' }}>
          <div className="row p32">
            <div className="c12-l-3">
              <h4 className="wide">Doctor's Scheduler</h4>
            </div>
            <div className="c12-l-7"></div>
            <div className="c12-l-2">
              <button onClick={openSchedule} type="button" name="button"
                className="btn solid round">Create Schedule</button>
            </div>
          </div>

          <div className="row mt16" >

            <table style={{ 'height': '100%', 'width': '100%', 'overflowY': 'scroll', 'overflowX': 'scroll', 'display': 'block' }}>
              <thead>
                <tr>
                  <th className="th-border center" width="5%">Id</th>
                  <th className="th-border left" width="20%">Name</th>
                  <th className="th-border left" width="15%">Days</th>
                  <th className="th-border left" width="15%">Time</th>
                  <th className="th-border left" width="5%">Sun</th>
                  <th className="th-border left" width="5%">Mon</th>
                  <th className="th-border left" width="5%">Tue</th>
                  <th className="th-border left" width="5%">Web</th>
                  <th className="th-border left" width="5%">Thu</th>
                  <th className="th-border left" width="5%">Fri</th>
                  <th className="th-border left" width="5%">Sat</th>
                  <th className="th-border left" width="15%">Edit</th>
                  <th className="th-border left" width="15%">Delete</th>
                </tr>
              </thead>
              <tbody >
                {
                  (dataStat === true ?
                    (
                      data.map((item, index) =>
                        <tr className="tr-border" key={index}>
                          <td className="center">{item.scheduleId}</td>
                          <td className="left">{item.doctorName}</td>
                          <td className="left">{item.DaysOfWeek}</td>
                          <td className="left">{item.time}</td>
                          <td className="left">{item.Sunday}</td>
                          <td className="left">{item.Monday}</td>
                          <td className="left">{item.Tuesday}</td>
                          <td className="left">{item.Wednesday}</td>
                          <td className="left">{item.Thusday}</td>
                          <td className="left">{item.Friday}</td>
                          <td className="left">{item.Saturday}</td>
                          <td onClick={() => { updateOperation(item.scheduleId) }} className="center"><img src={require('./asset/images/adm_edit.png')} alt="" /></td>
                          <td onClick={() => { deleteOperation(item.scheduleId) }} className="center"><img src={require('./asset/images/adm_del.png')} alt="" /></td>
                        </tr>
                      ))
                    : <tr><td>No data</td></tr>)
                }
              </tbody>
            </table>
          </div>

          {/* SCREEN FROM ADDING NEW SCHEDULE */}

          <div id="newdept" style={{ 'display': displaySchedule }} className="cont__new-dept">
            <form className="" action="" method="">
              <div className="row">
                <div className="c12-l-11"></div>
                <div className="c12-l-1 center">
                  <p onClick={closeSchedule}><img src={require('./asset/images/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt32">
                <div className="c12-l-12">
                  <h2>Add Schedule</h2>
                  <br />

                  <p style={{ 'fontSize': '0.75rem' }}>Select Doctor</p>
                  <select className="custom-select" onChange={(e) => setDoctorID(e.target.value)}>
                    <option value="0" >Select Doctor</option>
                    {
                      (doctorStat === true ?
                        (
                          doctorData.map((item2, index) =>
                            <option value={item2.doctorId} >{item2.name}</option>
                          ))
                        : <tr><td>No data</td></tr>)
                    }
                  </select>

                  <input type="text" className="box small" autoComplete="off"
                    placeholder="Days of the week" onChange={(e) => setDays(e.target.value)} />

                  <input type="text" className="box small" autoComplete="off"
                    placeholder="Times of the week" onChange={(e) => setTime(e.target.value)} />

                  <table>
                    <tr style={{ 'border': '1px solid black', 'borderColor': 'GrayText' }}>
                      <th>sun</th>
                      <th>Mon</th>
                      <th>Tue</th>
                      <th>Wed</th>
                      <th>Thr</th>
                      <th>Fri</th>
                      <th>Sat</th>

                    </tr>
                    <tr style={{ 'border': '1px solid black', 'borderColor': 'GrayText' }}>
                      <td><input type="checkbox" defaultChecked={false} name="sun" onChange={handleSunCheck} /></td>
                      <td><input type="checkbox" defaultChecked={false} name="mon" onChange={handleMonCheck} /></td>
                      <td><input type="checkbox" defaultChecked={false} name="tue" onChange={handleTueCheck} /></td>
                      <td><input type="checkbox" defaultChecked={false} name="wed" onChange={handleWedCheck} /></td>
                      <td><input type="checkbox" defaultChecked={false} name="thu" onChange={handleThuCheck} /></td>
                      <td><input type="checkbox" defaultChecked={false} name="fri" onChange={handleFriCheck} /></td>
                      <td><input type="checkbox" defaultChecked={false} name="sat" onChange={handleSatCheck} /></td>
                    </tr>
                  </table>

                  <br></br>
                  <button onClick={verifySchedule} type="button"
                    className="btn solid round">Add Schedule</button>
                </div>
              </div>
            </form>
          </div>

          {/* SCREEN FROM UPDTAE EXISTING USER */}

          <div id="newdept" style={{ 'display': displayUpdSchedule }} className="cont__new-dept">
            <form className="" action="" method="">
              <div className="row">
                <div className="c12-l-11"></div>
                <div className="c12-l-1 center">
                  <p onClick={closeUpdSchedule}><img src={require('./asset/images/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt32">
                <div className="c12-l-12">
                  <h2>Edit Schedule</h2><br /><br />

                  <input type="hidden" value={updSchId} />

                  <h3>{updDoctorsName}</h3><br />

                  <input type="text" className="box small"
                    placeholder="Days of the week" onChange={(e) => setDaysUpd(e.target.value)}
                    value={updDays} />

                  <input type="text" className="box small"
                    placeholder="Times of the week" onChange={(e) => setTimeUpd(e.target.value)}
                    value={updTime} />

                  <table>
                    <tr style={{ 'border': '1px solid black', 'borderColor': 'GrayText' }}>
                      <th>sun</th>
                      <th>Mon</th>
                      <th>Tue</th>
                      <th>Wed</th>
                      <th>Thu</th>
                      <th>Fri</th>
                      <th>Sat</th>

                    </tr>
                    <tr style={{ 'border': '1px solid black', 'borderColor': 'GrayText' }}>
                      <td><input type="checkbox" defaultChecked={updSun} onChange={updSunCheck} /></td>
                      <td><input type="checkbox" defaultChecked={updMon} onChange={updMonCheck} /></td>
                      <td><input type="checkbox" defaultChecked={updTue} onChange={updTueCheck} /></td>
                      <td><input type="checkbox" defaultChecked={updWed} onChange={updWedCheck} /></td>
                      <td><input type="checkbox" defaultChecked={updThu} onChange={updThuCheck} /></td>
                      <td><input type="checkbox" defaultChecked={updFri} onChange={updFriCheck} /></td>
                      <td><input type="checkbox" defaultChecked={updSat} onChange={updSatCheck} /></td>
                    </tr>
                  </table>

                  <br></br>
                  <button onClick={() => { updateSchedule(updSchId) }} type="button"
                    className="btn solid round">Update Schedule</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Scheduler;
